export default function changeUrl(text: string) {
    var regex = '/';
    text=text.replaceAll(regex, '-')
     regex = ' ';
     text=text.replaceAll(regex, '-')
     regex = '?';
     text=text.replaceAll(regex, '-')
     regex = '__';
     text=text.replaceAll(regex, '-')
     regex = '!';
     text=text.replaceAll(regex, '-')
     regex = '=';
     text=text.replaceAll(regex, '-')
     regex = '\\';
     text=text.replaceAll(regex, '-')
     regex = '&';
     text=text.replaceAll(regex, '-')
     regex = '#';
     text=text.replaceAll(regex, '-')

    return text;
}